// extracted by mini-css-extract-plugin
export default {"report":"LossControlReports_report__OKlUW","summary":"LossControlReports_summary__0Y1Xe","explanation":"LossControlReports_explanation__2o4dM"};